// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_settings.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { AdminSettingsService } from "./admin_settings_pb";

/**
 * SetSetting upserts one global key/value setting (value is raw JSON).
 *
 * @generated from rpc travplaces.v1.AdminSettingsService.SetSetting
 */
export const setSetting = AdminSettingsService.method.setSetting;

/**
 * RestartEngine is a no-op stub; it echoes the requested service back.
 *
 * @generated from rpc travplaces.v1.AdminSettingsService.RestartEngine
 */
export const restartEngine = AdminSettingsService.method.restartEngine;

/**
 * TestExternalSearch reports external-search availability (always false here).
 *
 * @generated from rpc travplaces.v1.AdminSettingsService.TestExternalSearch
 */
export const testExternalSearch = AdminSettingsService.method.testExternalSearch;
